import { useSpotlightState } from 'hooks/useSpotlightState'

export const useMeetingRecapViewed = () => {
  const [spotlights, updateSpotlights] = useSpotlightState()

  const hasViewedMeetingRecap = spotlights.meeting_recap_tour_dismissed === true

  const markMeetingRecapAsViewed = () => {
    if (!spotlights.meeting_recap_tour_dismissed) {
      updateSpotlights({ meeting_recap_tour_dismissed: true })
    }
  }

  return {
    hasViewedMeetingRecap,
    markMeetingRecapAsViewed
  }
}
